
import React, { Fragment, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button }from '@cmsgov/design-system';


// Components

import Form from '@lib/wrappers/Form';
import ModalHeader from '@common-components/headers/ModalHeader';
import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';




const OverrideCommentModal = props => {
    const {
        modalHeaderProps,
        actions: {
            hideModal
        },
        modal: {
            modalData: {
                override
            }
        },
        formName,
        methods,
        bottomAnchors: [
            anchor_1
        ],
        boundAnchor
    } = props;

    const [ localState, updateLocalState ] = useState({ comment: '' });

    const { comment } = localState;

    const handleOverrideClick = () => {
        methods[formName].onFormSubmitForValidationOnly([ () => override(comment), hideModal ]);
    };

    const onFieldChange = payload => {
        updateLocalState(localState => ({
            ...localState,
            ...payload
        }));
    };

    const MIN_LENGTH = 1;
    const MAX_LENGTH = 200;

    return (
        <Fragment>
            <div className = 'gi-modal__header__head'>
                <ModalHeader { ...{ ...modalHeaderProps, modalHeaderTextData: [ modalHeaderProps.modalHeaderTextData, { maxLength: MAX_LENGTH } ] }} />
            </div>
            <div className = 'gi-modal__body' id={`${modalHeaderProps.modalId}_body`}>
                <Form { ...{ formName } }>
                    <UniversalInput
                        label={{
                            text: 'ssap.input.label.comment'
                        }}
                        inputData={{
                            isInputRequired: true,
                            type: INPUT_TYPES.TEXTAREA,
                            name: 'comment',
                            value: comment,
                            currentData: localState,
                            placeholder: 'ssap.input.placeholder.provide_comment',
                            rows: 6,
                            validationType: VALIDATION_TYPES.LENGTH,
                            valuesToMatch: [ MIN_LENGTH, MAX_LENGTH ],
                            validationErrorValues: { min: MIN_LENGTH, max: MAX_LENGTH },
                            fields: []
                        }}
                        inputActions={{
                            onFieldChange
                        }}
                    />
                </Form>
            </div>
            <div className = 'gi-modal__footer'>
                <div className = 'grid-row controls'>
                    <div className = 'txt-center'>
                        <Button
                            className = 'usa-button gi-button gi-button__primary'
                            onClick = { hideModal }
                        >
                            <FormattedMessage id = 'button.close'/>
                        </Button>
                        <Button
                            className = 'usa-button gi-button gi-button__primary'
                            onClick = { handleOverrideClick }
                            inputRef = { boundAnchor(anchor_1) }
                        >
                            <FormattedMessage id = 'button.override'/>
                        </Button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default OverrideCommentModal;